import React, {
  // useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { Box } from '@mui/system';
import {
  Badge,
  Card,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import MediumTypography from '../../components/formlib/MediumTypography';
import KeyValueComponent, {
  DataJsonType,
} from '../../components/forms/KeyValueComponent';
import { HeadCell, TableHeader } from '../../components/formlib/TableHeader';
import TooltipTableCell from '../../components/formlib/TooltipTableCell';
import {
  DPHValues,
  InsuranceType,
  IntakeClientInfoDescriptionType,
  IntakeClientInfoEicsType,
  OptionType,
  ResponseType,
  employeeRoles,
} from '../../utils/type';
import { ReactComponent as AddNew } from '../../assets/images/Plus.svg';
import { Formik, FormikProps } from 'formik';
import * as yup from 'yup';
import CustomRadioButton from '../../components/formlib/CustomRadioButton';
import { EmployeeListType } from '../../services/ifspClient/IfspApi';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import {
  ContactsType,
  IfspTeamMembersType,
  ParentsType,
  TeamMembersType,
} from '../ifsp/ifspContextApi/IfspContex';
import IfspTeamMembersTableRow from '../ifsp/IfspTeamMemberTableRow';
import ModalPopup from '../../components/formlib/ModalPopup';
import CommentTextbox from '../../components/formlib/CommentTextbox';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import {
  IntakeClientInfoResponseType,
  getIntakeDetailsByTab,
  putIntakeClientInfo,
} from '../../services/configApi/forms/Intake/IntakeServices';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import { ApiError, isCustomError } from '../../services/ApiResponseHandler';
import { TabProps, showCancelToaster } from './IntakeTabNavigationComponent';
import {
  convertGenderToBackend,
  convertGenderToFrontend,
} from '../../utils/genderUtil';
import { calculateMonths } from '../../utils/dateUtil';
import { LookUpContext } from '../../context/LookUpContextProvider';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import AutocompleteSearch from '../../components/formlib/AutocompleteSearch';
import { DateString } from '../scheduler/EditSchedulerEventModal';
import dayjs, { Dayjs } from 'dayjs';
import _ from 'lodash';
import { formatName } from '../../utils/nameUtils';
import { isOtherLanguage } from '../../TranslateWidget';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import Textinput from '../../components/formlib/Textinput';
import { useMultiplePermissions } from '../../hooks/usePermissions';
import { REFERRAL_STATUS_KEY } from '../../services/Constant';
import LazyAutocompleteSearch from '../../components/formlib/LazyAutocompleteSearch';
import { getAllEmployeeByName } from '../../services/configApi/employees/employeeServices';

const CustomBadge = styled(Badge)(({ color }: { color?: string }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: color ?? '#FFA500',
    height: '8px',
    width: '8px',
    marginRight: '10px',
    position: 'relative',
    top: '3px',
  },
}));
export const badgePicker = (status: string) => {
  if (status === 'Inactive') {
    return (
      <CustomBadge
        variant="dot"
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: 'red',
          },
        }}
      />
    );
  } else {
    return <CustomBadge variant="dot" />;
  }
};

export interface RoutingProps {
  setTabProp: React.Dispatch<React.SetStateAction<TabProps>>;
}

export const EICSRadioData = [
  {
    value: 'Yes',
    labelId: 'Intake.RadioLabelA',
    defaultLabel: 'Yes',
  },
  {
    value: 'No',
    labelId: 'Intake.RadioLabelB',
    defaultLabel: 'No',
  },
  {
    value: 'Unknown',
    labelId: 'Intake.RadioLabelC',
    defaultLabel: 'Unknown',
  },
];

interface Data {
  name: string;
  type: string;
  Subscriber: string;
  tableEffectiveStartdate: string;
  effectivedate: string;
  status: string;
}

const headCells: HeadCell<Data>[] = [
  {
    id: 'name',
    labelId: 'Insurance.Name',
    defaultLabelId: 'Insurance Name',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'type',
    labelId: 'Insurance.Type',
    defaultLabelId: 'Type',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'Subscriber',
    labelId: 'Insurance.Subscriber',
    defaultLabelId: 'Subscriber',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'tableEffectiveStartdate',
    labelId: 'insurance.effectiveStartDate',
    defaultLabelId: 'Effective Start Date',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'effectivedate',
    labelId: 'Insurance.Effectivedate',
    defaultLabelId: 'Effective End Date',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'status',
    labelId: 'Insurance.status',
    defaultLabelId: 'Eligibility Status',
    numeric: false,
    requiredSorting: false,
  },
];

interface TableData {
  name: string;
  discipline: string;
  role: string;
  email: string;
  phoneNumber: string;
  actions: string;
}

const teamHeadCells: HeadCell<TableData>[] = [
  {
    id: 'name',
    labelId: 'Name',
    defaultLabelId: 'Name',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'discipline',
    labelId: 'Discipline',
    defaultLabelId: 'Discipline',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'role',
    labelId: 'Role',
    defaultLabelId: 'Role',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'email',
    labelId: 'Email',
    defaultLabelId: 'Email',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'phoneNumber',
    labelId: 'Phone Number',
    defaultLabelId: 'Phone Number',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'actions',
    labelId: 'Actions',
    defaultLabelId: 'Actions',
    numeric: false,
    requiredSorting: false,
  },
];

const validationSchema = yup.object().shape({
  formHandleFlag: yup.boolean(),
  PresentForIntakeVisitType: yup.string(),
  yetToAddOtherContactId: yup
    .string()
    .when(['PresentForIntakeVisitType', 'formHandleFlag'], {
      is: (PresentForIntakeVisitType: string, formHandleFlag: boolean) =>
        PresentForIntakeVisitType === 'teamMember' && !formHandleFlag,
      then: yup
        .string()
        .required('IFSP.yetToAddOtherContactId.validation')
        .nullable(),
      otherwise: yup.string().nullable(),
    }),
  yetToAddRoleId: yup
    .string()
    .when(['PresentForIntakeVisitType', 'formHandleFlag'], {
      is: (PresentForIntakeVisitType: string, formHandleFlag: boolean) =>
        PresentForIntakeVisitType === 'teamMember' && !formHandleFlag,
      then: yup.string().required('IFSP.yetToAddRoleId.validation').nullable(),
      otherwise: yup.string().nullable(),
    }),
  yetToAdddisciplineId: yup
    .string()
    .when(['PresentForIntakeVisitType', 'formHandleFlag'], {
      is: (PresentForIntakeVisitType: string, formHandleFlag: boolean) =>
        PresentForIntakeVisitType === 'teamMember' && !formHandleFlag,
      then: yup
        .string()
        .required('IFSP.yetToAddDisciplineId.validation')
        .nullable(),
      otherwise: yup.string().nullable(),
    }),
  yetToAddContactId: yup
    .string()
    .when(['PresentForIntakeVisitType', 'formHandleFlag'], {
      is: (PresentForIntakeVisitType: string, formHandleFlag: boolean) =>
        PresentForIntakeVisitType === 'parent' && !formHandleFlag,
      then: yup
        .string()
        .required('IFSP.yetToAddContactId.validation')
        .nullable(),
      otherwise: yup.string().nullable(),
    }),
  concernsDescription: yup.string(),
  prioritiesDescription: yup.string(),
  gainDescription: yup.string(),
  comment: yup.string(),
  primaryResidence: yup.string().nullable(),
  biologicalParents: yup.string().nullable(),
  childBorn: yup.string().nullable(),
  childAdopted: yup.string().nullable(),
  dateOfIntakeVisit: yup
    .date()
    .test({
      name: 'dateOfIntakeVisit',
      test: function (value) {
        const dateOfIntakeVisit = this.resolve(yup.ref('dateOfIntakeVisit'));
        if (value && dateOfIntakeVisit) {
          const pickerMin = '01/01/1900';
          const pickerMax = '12/31/2099';
          if (
            dayjs(value).isBefore(pickerMin) ||
            dayjs(value).isAfter(pickerMax)
          ) {
            return this.createError({
              path: this.path,
              message: 'datePickerMinDateMaxDateValidate',
            });
          }
        }
        return true;
      },
    })
    .nullable(),
});

export interface IntakeClientInfoType {
  demographics: DataJsonType[];
  insurance: InsuranceType[];
  guardians: ContactsType[];
  presentForIntakeVisits: {
    teamMembers: TeamMembersType[];
    guardians: ParentsType[];
  };
  dateOfIntakeVisit: DateString;
  descriptions: IntakeClientInfoDescriptionType;
  eics: IntakeClientInfoEicsType;
  biologicalParents: string;
  formHandleFlag: boolean;
  PresentForIntakeVisitType: string;
  yetToAddOtherContactId: string;
  yetToAddRoleId: string;
  yetToAdddisciplineId: string;
  yetToAddContactId: string;
  concernsDescription: string;
  prioritiesDescription: string;
  gainDescription: string;
  primaryResidence: string;
  comment: string;
}

export interface IntakeformikType {
  formHandleFlag: boolean;
  PresentForIntakeVisitType: string;
  yetToAddOtherContactId: string;
  yetToAddRoleId: string;
  descriptions: {
    childComeToFamilyDesc: string;
    childConcernDesc: string;
    familyConcernDesc: string;
    childPriorityDesc: string;
    familyPriorityDesc: string;
    earlyInterventionSupportDesc: string;
  };
  eics: {
    childBorn: string;
    childAdopted: string;
    mothersResidenceInMACode: string | null;
    mothersCommunityCode: string | null;
  };
  dateOfIntakeVisit: DateString;
  yetToAdddisciplineId: string;
  yetToAddContactId: string;
  biologicalParents: string;
  primaryResidence: string;
  comment: string;
}

const PresentForIntakeTypeData = [
  {
    value: 'parent',
    labelId: 'IFSP.GuardianText',
    defaultLabel: 'Guardian',
  },
  {
    value: 'teamMember',
    labelId: 'IFSP.TeamMemberText',
    defaultLabel: 'Team Member',
  },
];

const IntakeFormInitialValues = {
  demographics: [
    {
      id: 'ProgressNote.ClientName',
      labelid: 'ProgressNote.ClientName',
      defaultLabel: 'Client Name:',
      value: '-',
    },
    {
      id: 'ProgressNote.DPHID',
      labelid: 'ProgressNote.DPHID',
      defaultLabel: 'Enrollment ID:',
      value: '-',
    },
    {
      id: 'ProgressNote.DateofBirth',
      labelid: 'ProgressNote.DateofBirth',
      defaultLabel: 'Date of Birth:',
      value: '-',
    },
    {
      id: 'age',
      labelid: 'age',
      defaultLabel: 'Age:',
      value: '-',
    },
    {
      id: 'ProgressNote.Sex',
      labelid: 'ProgressNote.Sex',
      defaultLabel: 'Sex:',
      value: '-',
    },
    {
      id: 'ConsentForms.clientAddress',
      labelid: 'ConsentForms.clientAddress',
      defaultLabel: 'Address:',
      value: '-',
    },
  ],
  insurance: [],
  guardians: [],
  presentForIntakeVisits: {
    teamMembers: [],
    guardians: [],
  },
  descriptions: {
    childComeToFamilyDesc: '',
    childConcernDesc: '',
    familyConcernDesc: '',
    childPriorityDesc: '',
    familyPriorityDesc: '',
    earlyInterventionSupportDesc: '',
  },
  eics: {
    childBorn: '',
    childAdopted: '',
    mothersResidenceInMACode: null,
    mothersCommunityCode: null,
  },
  dateOfIntakeVisit: '',
  biologicalParents: '',
  formHandleFlag: false,
  PresentForIntakeVisitType: 'parent',
  yetToAddOtherContactId: '',
  yetToAddRoleId: '',
  yetToAdddisciplineId: '',
  yetToAddContactId: '',
  concernsDescription: '',
  prioritiesDescription: '',
  gainDescription: '',
  primaryResidence: '',
  comment: '',
};

interface UnsavedChangesWatcherProps {
  values: IntakeformikType;
  intakeClientInfo: IntakeClientInfoType;
  currentValues: IntakeformikType | undefined;
  initialIntakeTeamTable: IfspTeamMembersType[];
  intakeTeamTable: IfspTeamMembersType[];
  onUnsavedChangesChange: (hasUnsavedChanges: boolean) => void;
}

const UnsavedChangesWatcher = ({
  values,
  intakeClientInfo,
  currentValues,
  initialIntakeTeamTable,
  intakeTeamTable,
  onUnsavedChangesChange,
}: UnsavedChangesWatcherProps) => {
  useLayoutEffect(() => {
    const hasUnsavedChanges =
      !_.isEqual(intakeClientInfo, currentValues) ||
      !_.isEqual(initialIntakeTeamTable, intakeTeamTable);

    onUnsavedChangesChange(hasUnsavedChanges);
  }, [
    values,
    intakeClientInfo,
    currentValues,
    initialIntakeTeamTable,
    intakeTeamTable,
    onUnsavedChangesChange,
  ]);

  return null;
};

const IntakeClientsInfo: React.FC<RoutingProps> = ({ setTabProp }) => {
  const clientId = localStorage.getItem('ClientId');
  const [showAlertDialog, setShowAlertDialog] = useState<boolean>(false);
  const [deleteWarning, setDeleteWarning] = useState<boolean>(false);
  const [deleteIndex, setDeleteIndex] = useState<number>(0);
  const { toggleLoader } = React.useContext(LoaderContext) as LoaderContextType;

  const [toastrDefaultMessage, setToastrDefaultMessage] = React.useState('');
  const [toastrId, setToastrId] = useState<string>();
  const [successOrError, setSuccessOrError] = useState<ResponseType>('success');
  const [openModal, setOpenModal] = useState(false);
  const [empEditDisable, setEmpEditDisable] = useState(false);

  const [intakeClientInfo, setIntakeClientInfo] =
    useState<IntakeClientInfoType>(IntakeFormInitialValues);

  const [othersContactsRole, setOthersContactsRole] = useState<OptionType[]>(
    [],
  );
  const [otherContactDiscipline, setOtherContactDiscipline] = useState<
    OptionType[]
  >([]);
  const [intakeTeamTable, setIntakeTeamTable] = useState<IfspTeamMembersType[]>(
    [],
  );
  const [initialIntakeTeamTable, setInitialIntakeTeamTable] = useState<
    IfspTeamMembersType[]
  >([]);
  const [presentForIntakeType, setPresentForIntakeType] =
    useState<string>('parent');

  const formikRef = useRef<FormikProps<IntakeformikType>>(null);

  const [allGaurdians, setAllGaurdians] = useState<OptionType[]>([]);
  const [gaurdians, setGaurdians] = useState<ContactsType[]>([]);
  const [yetToAddContactId, setYetToAddContactId] = useState<string>('');
  const [initialTeamMembers, setInitialTeamMembers] = useState<
    IfspTeamMembersType[]
  >([]);
  const [teamMemberIds, setTeamMemberIds] = useState<string[]>([]);
  const [initiaGurdians, setInitiaGurdians] = useState<ParentsType[]>([]);

  const [editRecordIndex, setEditRecordIndex] = useState<number | null>(null);

  const [employeeList, setEmployeeList] = useState<EmployeeListType[]>([
    {
      id: '',
      name: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      disciplineType: '',
      disciplineHistoryList: [],
      roles: [],
    },
  ]);

  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
  ]);
  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';
  const [hasEditPermission, setHasEditPermission] = useState<boolean>(
    referralStatus === 'Inactive'
      ? permissions['backend.clients'].canEdit &&
          permissions['backend.in_active_referrals'].canEdit
      : permissions['backend.clients'].canEdit ||
          permissions['backend.in_active_referrals'].canEdit,
  );
  const [selectedEmployee, setSelectedEmployee] = useState<OptionType | null>(
    null,
  );

  const parentRef = React.useRef<HTMLDivElement>(null);

  const { lookups } = useContext(LookUpContext);

  const { handleUpdateUnsavedChanges } = useContext(UnSavedChangesContext);

  useEffect(() => {
    if (!hasEditPermission) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [hasEditPermission]);

  useEffect(() => {
    const handleIntakeGet = async () => {
      handleIntakeGetAPI();
    };
    handleIntakeGet();
  }, []);

  const handleIntakeGetAPI = async () => {
    window.scrollTo(0, 0);
    if (clientId) {
      toggleLoader(true);
      setPresentForIntakeType('parent');
      getIntakeDetailsByTab(clientId)
        .then((response: IntakeClientInfoResponseType) => {
          setGaurdians(response.guardians ?? []);
          const intakeTeamMembers: IfspTeamMembersType[] = [];

          response.presentForIntakeVisits.teamMembers.forEach((other) => {
            intakeTeamMembers.push(other);
          });

          response.presentForIntakeVisits.guardians.forEach((other) => {
            intakeTeamMembers.push(other);
          });
          setInitialIntakeTeamTable(intakeTeamMembers);
          setIntakeTeamTable(intakeTeamMembers);

          if (response.isSigned) {
            setHasEditPermission(false);
          } else if (response.isCurrentlyHeld) {
            setHasEditPermission(false);
            showCancelToaster(response.heldBy);
          }

          setIntakeClientInfo({
            ...intakeClientInfo,
            demographics: [
              {
                id: 'ProgressNote.ClientName',
                labelid: 'ProgressNote.ClientName',
                defaultLabel: 'Client Name:',
                value: response.demographics.name,
              },
              {
                id: 'ProgressNote.DPHID',
                labelid: 'ProgressNote.DPHID',
                defaultLabel: 'DPH ID:',
                value: response.demographics.dphId,
              },
              {
                id: 'ProgressNote.DateofBirth',
                labelid: 'ProgressNote.DateofBirth',
                defaultLabel: 'Date of Birth:',
                value: response.demographics.dateOfBirth,
              },
              {
                id: 'age',
                labelid: 'age',
                defaultLabel: 'Age:',
                value: `${calculateMonths(
                  response.demographics.dateOfBirth,
                ).replace(/[()]/g, '')}`,
              },
              {
                id: 'ProgressNote.Sex',
                labelid: 'ProgressNote.Sex',
                defaultLabel: 'Sex:',
                value:
                  convertGenderToFrontend(response.demographics.sex) ?? '-',
              },
              {
                id: 'ConsentForms.clientAddress',
                labelid: 'ConsentForms.clientAddress',
                defaultLabel: 'Address:',
                value: response.demographics.address,
              },
            ],
            guardians: response.guardians ?? [],
            presentForIntakeVisits: {
              teamMembers: response.presentForIntakeVisits.teamMembers,
              guardians: response.presentForIntakeVisits.guardians ?? [],
            },
            descriptions: {
              childComeToFamilyDesc:
                response.descriptions.childComeToFamilyDesc,
              childConcernDesc: response.descriptions.childConcernDesc,
              childPriorityDesc: response.descriptions.childPriorityDesc,
              earlyInterventionSupportDesc:
                response.descriptions.earlyInterventionSupportDesc,
              familyConcernDesc: response.descriptions.familyConcernDesc,
              familyPriorityDesc: response.descriptions.familyPriorityDesc,
            },
            eics: {
              childBorn: response.eics.childBorn,
              childAdopted: response.eics.childAdopted,
              mothersResidenceInMACode: response.eics.mothersResidenceInMACode,
              mothersCommunityCode: response.eics.mothersCommunityCode,
            },
            dateOfIntakeVisit: response.dateOfIntakeVisit,
            insurance: response.insurance,
            biologicalParents: response.biologicalParents,
            comment: response.comment ? response.comment : '',
          });
          setInitialTeamMembers(response.presentForIntakeVisits.teamMembers);
          setInitiaGurdians(response.presentForIntakeVisits.guardians ?? []);
          const teammemberIds = response.presentForIntakeVisits.teamMembers.map(
            (item) => item.id,
          );
          setTeamMemberIds(teammemberIds);
          fetchEmployees('', 0, teammemberIds);
          setTimeout(() => {
            toggleLoader(false);
          }, 100);
        })
        .catch((error) => {
          toggleLoader(false);
          setSuccessOrError('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId(error);
            setToastrDefaultMessage(error);
          }
        });
    }
  };

  const sanitizeSearch = (text: string) => {
    if (!text) return '';

    if (text.includes(',')) {
      const [last, first] = text.split(',');
      return `${first?.trim()} ${last?.trim()}`;
    }

    return text;
  };

  const fetchEmployees = (
    search: string,
    page: number,
    memberIds: string[] = [],
  ): Promise<OptionType[]> => {
    let memberIdsToUse;
    if (presentForIntakeType === 'teamMember' && page === 0) {
      memberIdsToUse = teamMemberIds;
      toggleLoader(true);
    } else {
      memberIdsToUse = memberIds;
      toggleLoader(false);
    }
    const cleanSearch = sanitizeSearch(search);
    return getAllEmployeeByName(
      cleanSearch,
      page,
      10,
      page === 0 ? memberIdsToUse : [],
    )
      .then((data) => {
        setEmployeeList((prev) => {
          const merged = page === 0 ? data : [...prev, ...data];

          setInitialIntakeTeamTable((prevTable) =>
            prevTable.map((item) => {
              if (!item.discipline) return item;

              const emp = merged.find((e) => e.id === item.id);

              return {
                ...item,
                name: formatName(
                  emp?.firstName ?? '',
                  null,
                  emp?.lastName ?? '',
                  null,
                ),
              };
            }),
          );

          setIntakeTeamTable((prevTable) =>
            prevTable.map((item) => {
              if (!item.discipline) return item;

              const emp = merged.find((e) => e.id === item.id);

              return {
                ...item,
                name: formatName(
                  emp?.firstName ?? '',
                  null,
                  emp?.lastName ?? '',
                  null,
                ),
              };
            }),
          );

          return merged;
        });

        toggleLoader(false);

        return data.map((emp) => ({
          id: emp.id,
          label: `${emp.lastName}, ${emp.firstName}`,
        }));
      })
      .catch((err) => {
        toggleLoader(false);
        setSuccessOrError('error');
        setToastrId('IFSP.failedToGetEmployeeData');
        setToastrDefaultMessage(err);

        return [];
      });
  };

  useEffect(() => {
    if (editRecordIndex !== null) {
      const data = intakeTeamTable[editRecordIndex];

      setSelectedEmployee({
        id: data.id,
        label:
          employeeList.find((emp) => emp.id === data.id)?.lastName +
            ', ' +
            employeeList.find((emp) => emp.id === data.id)?.firstName || '',
      });

      setOthersContactsRole(() => {
        const filteredContactsRoles: OptionType[] = employeeList
          .filter((contact) => contact.id === data?.id)
          .flatMap((contact) =>
            contact.roles
              ? contact.roles.flatMap((roleString) =>
                  roleString.split(',').map((roleId) => ({
                    id: roleId.trim(),
                    label:
                      employeeRoles.find(
                        (empRole) => empRole.id === roleId.trim(),
                      )?.label ?? '',
                  })),
                )
              : [],
          );
        const val = filteredContactsRoles.find(
          (contact) => contact.id === data.role,
        );
        formikRef.current?.setFieldValue('yetToAddRoleId', val ? val.id : null);
        return filteredContactsRoles;
      });

      if (lookups === null) {
        return;
      }

      setOtherContactDiscipline(() => {
        if (!employeeList || !lookups?.employeeDiscipline) return [];

        const disciplines: OptionType[] = employeeList
          .filter((contact) => contact.id === data?.id)
          .flatMap((contact) =>
            (contact.disciplineHistoryList || []).map((history) => ({
              id: history.disciplineType,
              label:
                lookups.employeeDiscipline.find(
                  (dis) => dis.code === history.disciplineType,
                )?.description || '',
            })),
          );

        // Remove duplicates by id (disciplineType)
        const uniqueDisciplines = Array.from(
          new Map(disciplines.map((d) => [d.id, d])).values(),
        );

        formikRef.current?.setFieldValue(
          'yetToAdddisciplineId',
          data.discipline,
        );

        return uniqueDisciplines;
      });

      formikRef.current?.setFieldValue('yetToAddOtherContactId', data.id);
      formikRef.current?.setFieldValue('yetToAddRoleId', data.role);
      formikRef.current?.setFieldValue('yetToAdddisciplineId', data.discipline);
    }
  }, [employeeList, editRecordIndex, intakeTeamTable]);

  useEffect(() => {
    setAllGaurdians(() => {
      const formattedContacts: OptionType[] = gaurdians
        .filter(
          (contact) =>
            !intakeTeamTable.some(
              (parent) => parent.id.toString() === contact.id.toString(),
            ),
        )
        .map((filteredContact) => {
          const prefixes = [
            filteredContact.isPrimary && 'Primary',
            filteredContact.isLegal && 'Legal',
          ].filter(Boolean);

          return {
            id: filteredContact.id,
            label: `${filteredContact.name}${
              filteredContact.isGuardian && prefixes.length > 0
                ? ` - (${prefixes.join(', ')})`
                : ''
            }`,
          };
        });
      setIntakeClientInfo({
        ...intakeClientInfo,
        PresentForIntakeVisitType: presentForIntakeType,
        presentForIntakeVisits: {
          guardians: intakeTeamTable.filter(
            (parent) =>
              parent.discipline === undefined ||
              parent.discipline === '' ||
              parent.discipline === null,
          ),
          teamMembers: intakeTeamTable.filter(
            (teamMember) => teamMember.discipline,
          ),
        },
      });
      return formattedContacts;
    });
  }, [intakeTeamTable, gaurdians]);

  const handleAddNewContact = async () => {
    const newContact = gaurdians.find(
      (contact) => contact.id === yetToAddContactId,
    );
    if (newContact) {
      const prefixes = [
        newContact.isPrimary && 'Primary',
        newContact.isLegal && 'Legal',
      ].filter(Boolean);

      setIntakeTeamTable((prev) => {
        return [
          ...prev,
          {
            id: newContact.id.toString(),
            email: newContact.email,
            name: `${newContact.name}${
              prefixes.length > 0 ? ` - (${prefixes.join(', ')})` : ''
            }`,
            phone: newContact.phone,
            role: newContact.relationshipToClient,
          },
        ];
      });
      if (formikRef.current) {
        setIntakeClientInfo({
          ...intakeClientInfo,
          dateOfIntakeVisit: formikRef.current.values.dateOfIntakeVisit,
          presentForIntakeVisits: {
            ...intakeClientInfo.presentForIntakeVisits,
            teamMembers: [
              ...intakeClientInfo.presentForIntakeVisits.teamMembers,
            ],
            guardians: [
              ...intakeClientInfo.presentForIntakeVisits.guardians,
              {
                id: newContact.id.toString(),
                email: newContact.email,
                name: newContact.name,
                phone: newContact.phone,
                role: newContact.relationshipToClient,
              },
            ],
          },
          eics: {
            childBorn: formikRef.current.values.eics.childBorn,
            childAdopted: formikRef.current.values.eics.childAdopted,
            mothersResidenceInMACode:
              formikRef.current.values.eics.mothersResidenceInMACode,
            mothersCommunityCode:
              formikRef.current.values.eics.mothersCommunityCode,
          },
          descriptions: {
            childComeToFamilyDesc:
              formikRef.current.values.descriptions.childComeToFamilyDesc,
            childConcernDesc:
              formikRef.current.values.descriptions.childConcernDesc,
            childPriorityDesc:
              formikRef.current.values.descriptions.childPriorityDesc,
            earlyInterventionSupportDesc:
              formikRef.current.values.descriptions
                .earlyInterventionSupportDesc,
            familyConcernDesc:
              formikRef.current.values.descriptions.familyConcernDesc,
            familyPriorityDesc:
              formikRef.current.values.descriptions.familyPriorityDesc,
          },
          yetToAddOtherContactId:
            formikRef.current.values.yetToAddOtherContactId,
          yetToAddRoleId: formikRef.current.values.yetToAddRoleId,
          yetToAdddisciplineId: formikRef.current.values.yetToAdddisciplineId,
          primaryResidence: formikRef.current.values.primaryResidence,
          biologicalParents: formikRef.current.values.biologicalParents,
          comment: formikRef.current.values.comment,
        });
      }
    }
    setYetToAddContactId('');
    formikRef.current?.setValues({
      ...formikRef.current?.values,
      yetToAddContactId: '',
    });
    formikRef.current?.setFieldValue('PresentForIntakeVisitType', 'parent');
  };

  const handleAddNewOtherContact = async (
    submittedValues: IntakeformikType,
  ) => {
    setEmpEditDisable(false);
    setTeamMemberIds((prev) => {
      if (prev.includes(submittedValues.yetToAddOtherContactId)) return prev; // prevent duplicate
      return [...prev, submittedValues.yetToAddOtherContactId];
    });

    const newOtherContact = employeeList.find(
      (employee) => employee.id === submittedValues.yetToAddOtherContactId,
    );
    const isDuplicated = intakeTeamTable.map((otherContact) => {
      const isRecordDuplicated =
        (otherContact.role === submittedValues.yetToAddRoleId ||
          otherContact.discipline === submittedValues.yetToAdddisciplineId) &&
        otherContact.id === newOtherContact?.id;

      return isRecordDuplicated;
    });

    if (editRecordIndex !== null && !isDuplicated.includes(true)) {
      const updatedRecord = {
        id: newOtherContact?.id ?? intakeTeamTable[editRecordIndex].id,
        email: newOtherContact?.email ?? intakeTeamTable[editRecordIndex].email,
        name:
          formatName(
            newOtherContact?.firstName ?? '',
            null,
            newOtherContact?.lastName ?? '',
            null,
          ) ?? intakeTeamTable[editRecordIndex].name,
        phone: newOtherContact?.phone ?? intakeTeamTable[editRecordIndex].phone,
        role:
          formikRef.current?.values.yetToAddRoleId ??
          intakeTeamTable[editRecordIndex].role,
        discipline:
          formikRef.current?.values.yetToAdddisciplineId ??
          intakeTeamTable[editRecordIndex].discipline,
      };
      setIntakeTeamTable((prev) => {
        const updatedTable = [...prev];
        updatedTable[editRecordIndex] = updatedRecord;

        if (formikRef.current) {
          setIntakeClientInfo({
            ...intakeClientInfo,
            presentForIntakeVisits: {
              ...intakeClientInfo.presentForIntakeVisits,
              teamMembers: updatedTable.filter(
                (item) => typeof item.id === 'number',
              ),
            },
            eics: {
              childBorn: formikRef.current.values.eics.childBorn,
              childAdopted: formikRef.current.values.eics.childAdopted,
              mothersResidenceInMACode:
                formikRef.current.values.eics.mothersResidenceInMACode,
              mothersCommunityCode:
                formikRef.current.values.eics.mothersCommunityCode,
            },
            descriptions: {
              childComeToFamilyDesc:
                formikRef.current.values.descriptions.childComeToFamilyDesc,
              childConcernDesc:
                formikRef.current.values.descriptions.childConcernDesc,
              childPriorityDesc:
                formikRef.current.values.descriptions.childPriorityDesc,
              earlyInterventionSupportDesc:
                formikRef.current.values.descriptions
                  .earlyInterventionSupportDesc,
              familyConcernDesc:
                formikRef.current.values.descriptions.familyConcernDesc,
              familyPriorityDesc:
                formikRef.current.values.descriptions.familyPriorityDesc,
            },
            yetToAddOtherContactId: '',
            yetToAddRoleId: '',
            yetToAdddisciplineId: '',
            biologicalParents: '',
            comment: formikRef.current.values.comment,
          });
        }

        return updatedTable;
      });
    } else if (
      newOtherContact &&
      !isDuplicated.includes(true) &&
      formikRef.current
    ) {
      setIntakeTeamTable((prev) => {
        return [
          ...prev,
          {
            id: newOtherContact.id || '',
            email: newOtherContact.email ?? '',
            name:
              formatName(
                newOtherContact?.firstName ?? '',
                null,
                newOtherContact?.lastName ?? '',
                null,
              ) ?? '',
            phone: newOtherContact.phone ?? '',
            role: formikRef.current?.values.yetToAddRoleId || '',
            discipline: formikRef.current?.values.yetToAdddisciplineId || '',
          },
        ];
      });
      setIntakeClientInfo({
        ...intakeClientInfo,
        dateOfIntakeVisit: formikRef.current.values.dateOfIntakeVisit,
        presentForIntakeVisits: {
          ...intakeClientInfo.presentForIntakeVisits,
          teamMembers: [
            ...intakeClientInfo.presentForIntakeVisits.teamMembers,
            {
              id: newOtherContact.id || '',
              email: newOtherContact.email ?? '',
              name:
                formatName(
                  newOtherContact?.firstName ?? '',
                  null,
                  newOtherContact?.lastName ?? '',
                  null,
                ) ?? '',
              phone: newOtherContact.phone ?? '',
              role: formikRef.current?.values.yetToAddRoleId || '',
              discipline: formikRef.current?.values.yetToAdddisciplineId || '',
            },
          ],
        },
        eics: {
          childBorn: formikRef.current.values.eics.childBorn,
          childAdopted: formikRef.current.values.eics.childAdopted,
          mothersResidenceInMACode:
            formikRef.current.values.eics.mothersResidenceInMACode,
          mothersCommunityCode:
            formikRef.current.values.eics.mothersCommunityCode,
        },
        descriptions: {
          childComeToFamilyDesc:
            formikRef.current.values.descriptions.childComeToFamilyDesc,
          childConcernDesc:
            formikRef.current.values.descriptions.childConcernDesc,
          childPriorityDesc:
            formikRef.current.values.descriptions.childPriorityDesc,
          earlyInterventionSupportDesc:
            formikRef.current.values.descriptions.earlyInterventionSupportDesc,
          familyConcernDesc:
            formikRef.current.values.descriptions.familyConcernDesc,
          familyPriorityDesc:
            formikRef.current.values.descriptions.familyPriorityDesc,
        },
        yetToAddOtherContactId: '',
        yetToAddRoleId: '',
        yetToAdddisciplineId: '',
        primaryResidence: '',
        biologicalParents: '',
        comment: formikRef.current.values.comment,
      });
    } else if (isDuplicated.includes(true)) {
      await formikRef.current?.setFieldValue('formHandleFlag', true);
      setShowAlertDialog(true);
    }
    formikRef.current?.resetForm();
    setSelectedEmployee(null);
    setEditRecordIndex(null);
    setOthersContactsRole([]);
    setOtherContactDiscipline([]);
  };

  const handleEditOtherContact = async (editIndex: number) => {
    setEmpEditDisable(true);
    setEditRecordIndex(editIndex);
    const data = intakeTeamTable[editIndex];
    if (data) {
      formikRef.current?.setTouched({}, false);
    }
  };

  const handleDeleteOtherContact = (index: number) => {
    formikRef.current?.setFieldValue('yetToAddOtherContactId', null);
    formikRef.current?.setFieldError('yetToAddOtherContactId', '');
    formikRef.current?.setFieldValue('yetToAdddisciplineId', null);
    formikRef.current?.setFieldError('yetToAdddisciplineId', '');
    formikRef.current?.setFieldValue('yetToAddRoleId', null);
    formikRef.current?.setFieldError('yetToAddRoleId', '');
    setEmpEditDisable(false);
    setOthersContactsRole([]);
    setOtherContactDiscipline([]);
    setEditRecordIndex(null);
    setDeleteIndex(index);
    setDeleteWarning(true);
  };

  const handleSubmitForm = async () => {
    if (formikRef.current) {
      const params: IntakeClientInfoResponseType = {
        demographics: {
          name: intakeClientInfo.demographics[0].value,
          dphId: intakeClientInfo.demographics[1].value,
          dateOfBirth: intakeClientInfo.demographics[2].value,
          ageInMonths: intakeClientInfo.demographics[3].value,
          sex: convertGenderToBackend(intakeClientInfo.demographics[4].value),
          address: intakeClientInfo.demographics[5].value,
        },
        insurance: intakeClientInfo.insurance,
        presentForIntakeVisits: {
          teamMembers: intakeClientInfo.presentForIntakeVisits.teamMembers.map(
            (prev) => ({
              ...prev,
              name:
                employeeList.find((emp) => emp.id === prev.id)?.firstName +
                ' ' +
                employeeList.find((emp) => emp.id === prev.id)?.lastName,
            }),
          ),
          guardians: intakeClientInfo.presentForIntakeVisits.guardians,
        },
        biologicalParents: intakeClientInfo.biologicalParents,
        eics: {
          childBorn: formikRef.current.values.eics.childBorn,
          childAdopted: formikRef.current.values.eics.childAdopted,
          mothersResidenceInMACode:
            formikRef.current.values.eics.mothersResidenceInMACode,
          mothersCommunityCode:
            formikRef.current.values.eics.mothersCommunityCode,
        },
        dateOfIntakeVisit: formikRef.current.values.dateOfIntakeVisit,
        descriptions: {
          childComeToFamilyDesc:
            formikRef.current.values.descriptions.childComeToFamilyDesc,
          childConcernDesc:
            formikRef.current.values.descriptions.childConcernDesc,
          childPriorityDesc:
            formikRef.current.values.descriptions.childPriorityDesc,
          earlyInterventionSupportDesc:
            formikRef.current.values.descriptions.earlyInterventionSupportDesc,
          familyConcernDesc:
            formikRef.current.values.descriptions.familyConcernDesc,
          familyPriorityDesc:
            formikRef.current.values.descriptions.familyPriorityDesc,
        },
        comment: formikRef.current.values.comment,
      };

      toggleLoader(true);
      if (clientId) {
        putIntakeClientInfo(clientId, params)
          .then(async (response) => {
            if (response) {
              setSuccessOrError('success');
              setToastrId('Intake.successMsg');
              setToastrDefaultMessage('Intake updated successfully');
              await formikRef.current?.setFieldValue(
                'PresentForIntakeVisitType',
                'parent',
              );
              await formikRef.current?.setFieldValue('formHandleFlag', false);
              await formikRef.current?.setFieldValue(
                'yetToAddOtherContactId',
                '',
              );
              await formikRef.current?.setFieldValue(
                'yetToAdddisciplineId',
                '',
              );
              await formikRef.current?.setFieldValue('yetToAddRoleId', '');
              setEmpEditDisable(false);

              setTimeout(() => {
                handleUpdateUnsavedChanges(false);
                toggleLoader(false);
                setTabProp((value) => {
                  sessionStorage.setItem(
                    'intakeTabName',
                    String(value.tabPosition),
                  );
                  return {
                    tabPosition: value.tabPosition,
                  };
                });
              }, 1000);

              handleIntakeGetAPI();
            }
          })
          .catch((error) => {
            toggleLoader(false);
            setSuccessOrError('error');
            if (isCustomError(error)) {
              const apiError = error as ApiError;
              setToastrId(apiError.id);
              setToastrDefaultMessage(apiError.message);
            } else {
              setToastrId(error);
              setToastrDefaultMessage(error);
            }
          });
      }
    }
  };

  const getCompanyName = (data: InsuranceType) => {
    if (data.dph3rdPartyPayerName && data.dph3rdPartyPayer === 'OTHER') {
      return `${data.dph3rdPartyPayerName} - ${data.insuranceCompany}`;
    } else if (data.dph3rdPartyPayer && data.dph3rdPartyPayerName) {
      return `${data.dph3rdPartyPayer} - ${data.dph3rdPartyPayerName}`;
    } else {
      return '-';
    }
  };

  return (
    <>
      {toastrId && (
        <SnackBarComponent
          open={toastrId !== undefined}
          handleClose={() => {
            setToastrId(undefined);
          }}
          labelId={toastrId}
          defaultMessageId={toastrDefaultMessage}
          successOrError={successOrError}
          snackbarProps={{
            top: '60px !important',
          }}
        />
      )}
      {console.log('sdasd', hasEditPermission)}
      <Box
        ref={parentRef}
        style={{
          pointerEvents: hasEditPermission ? 'auto' : 'none',
          opacity: hasEditPermission ? 'unset' : '0.8',
        }}
      >
        <Card className="formCardview gray3 borderRadius4 mt-md mb-md p-sm">
          <Box component="div">
            <ModalPopup
              open={showAlertDialog}
              description="duplicateIntakeTeamWarningMessage"
              onOk={() => {
                setShowAlertDialog(false);
              }}
              labelId2="Clientpage.Okbtn"
              positiveActionLabel="Ok"
            />
            <ModalPopup
              open={deleteWarning}
              description="deleteConfirmationMessage"
              onOk={async () => {
                const updatedTeamMembers = intakeTeamTable.filter(
                  (__, i) => i !== deleteIndex,
                );
                if (formikRef.current) {
                  setIntakeTeamTable(updatedTeamMembers);
                  setIntakeClientInfo({
                    ...intakeClientInfo,
                    presentForIntakeVisits: {
                      ...intakeClientInfo.presentForIntakeVisits,
                      teamMembers: updatedTeamMembers,
                    },
                    eics: {
                      childBorn: formikRef.current.values.eics.childBorn,
                      childAdopted: formikRef.current.values.eics.childAdopted,
                      mothersResidenceInMACode:
                        formikRef.current.values.eics.mothersResidenceInMACode,
                      mothersCommunityCode:
                        formikRef.current.values.eics.mothersCommunityCode,
                    },
                    yetToAddOtherContactId:
                      formikRef.current.values.yetToAddOtherContactId,
                    yetToAddRoleId: formikRef.current.values.yetToAddRoleId,
                    yetToAdddisciplineId:
                      formikRef.current.values.yetToAdddisciplineId,
                    descriptions: {
                      childComeToFamilyDesc:
                        formikRef.current.values.descriptions
                          .childComeToFamilyDesc,
                      childConcernDesc:
                        formikRef.current.values.descriptions.childConcernDesc,
                      childPriorityDesc:
                        formikRef.current.values.descriptions.childPriorityDesc,
                      earlyInterventionSupportDesc:
                        formikRef.current.values.descriptions
                          .earlyInterventionSupportDesc,
                      familyConcernDesc:
                        formikRef.current.values.descriptions.familyConcernDesc,
                      familyPriorityDesc:
                        formikRef.current.values.descriptions
                          .familyPriorityDesc,
                    },
                    primaryResidence: formikRef.current.values.primaryResidence,
                    biologicalParents:
                      formikRef.current.values.biologicalParents,
                    comment: formikRef.current.values.comment,
                  });

                  setDeleteWarning(false);
                }
              }}
              onCancel={() => {
                setDeleteWarning(false);
              }}
              labelId1="Clientpage.cancelbtn"
              negativeActionLabel="cancelText"
              labelId2="Clientpage.Okbtn"
              positiveActionLabel="Ok"
            />
            <Formik
              initialValues={intakeClientInfo}
              innerRef={formikRef}
              validateOnMount={true}
              validateOnChange={true}
              enableReinitialize
              validationSchema={validationSchema}
              onSubmit={async (values, { setFieldValue, setFieldError }) => {
                if (presentForIntakeType === 'teamMember') {
                  await handleAddNewOtherContact(values);
                  setFieldValue('yetToAddOtherContactId', '');
                  setFieldError('yetToAddOtherContactId', '');
                  setFieldValue('yetToAdddisciplineId', '');
                  setFieldError('yetToAdddisciplineId', '');
                  setFieldValue('yetToAddRoleId', '');
                  setFieldError('yetToAddRoleId', '');
                  setFieldValue('PresentForIntakeVisitType', 'teamMember');
                  formikRef.current?.setTouched({}, false);
                } else if (presentForIntakeType === 'parent') {
                  await handleAddNewContact();
                  setFieldValue('yetToAddContactId', '');
                  setFieldError('yetToAddContactId', '');
                  setFieldValue('PresentForIntakeVisitType', 'parent');
                  formikRef.current?.setTouched({}, false);
                }
              }}
            >
              {({ values, setFieldValue, errors, touched, handleSubmit }) => {
                return (
                  <Box component="div">
                    <UnsavedChangesWatcher
                      values={values}
                      intakeClientInfo={intakeClientInfo}
                      currentValues={formikRef.current?.values}
                      initialIntakeTeamTable={initialIntakeTeamTable}
                      intakeTeamTable={intakeTeamTable}
                      onUnsavedChangesChange={handleUpdateUnsavedChanges}
                    />
                    <Box
                      component="div"
                      className="p-sm gray3 borderRadius4"
                      sx={{
                        border: '1px solid #00C6B8',
                      }}
                    >
                      <Box component="div">
                        <MediumTypography
                          labelid="Demographic.Titletext"
                          defaultlabel="Demographic"
                          fontSize="16px"
                          fontweight={600}
                          textColor="#2A4241"
                        />
                        <Box
                          component="div"
                          className="flex__ align__items__center mt-md"
                        >
                          <KeyValueComponent
                            data={intakeClientInfo.demographics}
                          />
                        </Box>
                      </Box>
                      <Box component="div" className="mt-md">
                        <MediumTypography
                          labelid="Facesheet.insurance"
                          defaultlabel="Insurance"
                          fontSize="16px"
                          fontweight={600}
                          textColor="#2A4241"
                          className="mb-md"
                        />
                        <TableContainer sx={{ maxHeight: 310 }}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHeader
                              className="listDataTableHead"
                              headerNames={headCells}
                              checkBoxRequired={false}
                            />

                            <TableBody className="tableRowcss">
                              {intakeClientInfo.insurance.map(
                                (row: InsuranceType, index: number) => (
                                  <TableRow
                                    hover
                                    tabIndex={-1}
                                    key={row.coverageType2}
                                    sx={{
                                      cursor: 'pointer',
                                      backgroundColor:
                                        index % 2 === 0 ? '#ECF9F8' : '#ffffff',
                                    }}
                                  >
                                    {/* <TableCell> {index + 1}</TableCell> */}
                                    <TooltipTableCell
                                      value={getCompanyName(row)}
                                      visible={true}
                                    />
                                    <TooltipTableCell
                                      value={
                                        row.coverageType2
                                          ? row.coverageType2
                                          : '-'
                                      }
                                      visible={true}
                                    />
                                    <TooltipTableCell
                                      value={row.subscriberName}
                                      visible={true}
                                    />
                                    <TableCell>
                                      {row.effectiveStartDate
                                        ? ` ${row.effectiveStartDate} `
                                        : '-'}
                                    </TableCell>
                                    <TableCell>
                                      {row.effectiveEndDate
                                        ? ` ${row.effectiveEndDate} `
                                        : '-'}
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        fontFamily: 'Lato-Regular',
                                      }}
                                    >
                                      {badgePicker('Not Verified')}
                                      Not verified
                                    </TableCell>
                                  </TableRow>
                                ),
                              )}
                            </TableBody>
                          </Table>
                          {intakeClientInfo.insurance.length === 0 && (
                            <Box
                              component="div"
                              className="width__100 flex__align__center"
                            >
                              <MediumTypography
                                sxProps={{ backgroundColor: '#ECF9F8' }}
                                textstyle={'center'}
                                labelid="Insurance.nodataValidation"
                                defaultlabel="No Insurance added yet"
                                className="p-sm"
                              />
                            </Box>
                          )}
                        </TableContainer>
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="row"
                        className="mt-md align__items__center"
                      >
                        <Box>
                          <MediumTypography
                            labelid="IntakeClientInfo.dateOfIntakeVisit"
                            defaultlabel="Date of Intake Visit"
                          />
                        </Box>
                        <Box>
                          <DatePickerComponent
                            className="bg__white ml-md"
                            labelid={'IntakeClientInfo.dateOfIntakeVisit'}
                            defaultlabelid={'Date of Intake Visit'}
                            value={dayjs(values.dateOfIntakeVisit)}
                            handlechange={(date: Dayjs | null) => {
                              if (date) {
                                const formattedDate =
                                  date.format('MM/DD/YYYY') || '';
                                formikRef.current?.setValues({
                                  ...formikRef.current?.values,
                                  dateOfIntakeVisit: formattedDate,
                                });
                              } else {
                                formikRef.current?.setValues({
                                  ...formikRef.current?.values,
                                  dateOfIntakeVisit: null,
                                });
                              }
                            }}
                          />
                          {errors.dateOfIntakeVisit && (
                            <MediumTypography
                              className="errorText-md ml-md"
                              labelid={errors.dateOfIntakeVisit}
                              defaultlabel="Date of Intake Visit is required"
                            />
                          )}
                        </Box>
                      </Box>
                      <Box className="mt-md">
                        <MediumTypography
                          labelid="IntakeCurrentHealth.presentForIntake"
                          defaultlabel="Present for Intake"
                          fontSize="16px"
                          fontweight={600}
                          textColor="#2A4241"
                        />
                        <CustomRadioButton
                          data={PresentForIntakeTypeData}
                          value={presentForIntakeType}
                          onSelectItem={(e) => {
                            formikRef.current?.setTouched({}, false);
                            setSelectedEmployee(null);
                            setEmpEditDisable(false);
                            setEditRecordIndex(null);
                            setOthersContactsRole([]);
                            setOtherContactDiscipline([]);
                            if (e) {
                              formikRef.current?.setValues({
                                ...formikRef.current?.values,
                                PresentForIntakeVisitType: e, // Preserving specific values if needed
                                yetToAddContactId: '',
                                yetToAdddisciplineId: '',
                                yetToAddOtherContactId: '',
                                yetToAddRoleId: '',
                              });
                              setYetToAddContactId('');
                              setPresentForIntakeType(e);
                              setFieldValue('PresentForIntakeVisitType', e);
                            }
                          }}
                          className="mt-md"
                        />
                        {presentForIntakeType === 'parent' && (
                          <Box component="div">
                            <Grid
                              container
                              direction={'row'}
                              className="mt-md mb-lg"
                            >
                              <Grid item xs={5}>
                                <AutocompleteSearch
                                  className="bg__white"
                                  data={allGaurdians}
                                  labelId="IFSP.selectName"
                                  defaultId="Select Name"
                                  Required={true}
                                  selectedValue={{
                                    id:
                                      allGaurdians.find(
                                        (item) => item.id === yetToAddContactId,
                                      )?.id ?? '',
                                    label:
                                      allGaurdians.find(
                                        (item) => item.id === yetToAddContactId,
                                      )?.label ?? '',
                                  }}
                                  onSelectItem={(e) => {
                                    if (e) {
                                      setYetToAddContactId(e.id);
                                      setFieldValue('yetToAddContactId', e.id);
                                    } else {
                                      setYetToAddContactId('');
                                      setFieldValue('yetToAddContactId', '');
                                    }
                                  }}
                                  disableLabel={false}
                                />
                                {errors.yetToAddContactId &&
                                  touched.yetToAddContactId && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.yetToAddContactId}
                                      defaultlabel="Guardian is required"
                                    />
                                  )}
                              </Grid>

                              <Grid
                                item
                                xs={1}
                                className="cursorPointer align__items__center flex__justify__center"
                                onClick={() => {
                                  handleSubmit();
                                }}
                              >
                                <Box component="div" className="flex__ mt-xs ">
                                  <AddNew className="ml-sm" />
                                  <MediumTypography
                                    labelid="IFSP.Add"
                                    defaultlabel="Add"
                                    className="pl-sm"
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        )}
                        {presentForIntakeType === 'teamMember' && (
                          <Box component="div" className="mt-md mb-md">
                            <Grid container columnSpacing={'24px'}>
                              <Grid item xs={3}>
                                <LazyAutocompleteSearch
                                  labelId="Intake.SelectEmployee"
                                  defaultId="Select Employee"
                                  value={selectedEmployee}
                                  onChange={(e) => {
                                    if (e) {
                                      setSelectedEmployee(e);
                                      setOthersContactsRole(() => {
                                        const filteredContactsRoles: OptionType[] =
                                          employeeList
                                            .filter(
                                              (contact) => contact.id === e.id,
                                            )
                                            .flatMap((contact) =>
                                              contact.roles
                                                ? contact.roles.flatMap(
                                                    (roleString) =>
                                                      roleString
                                                        .split(',')
                                                        .map((roleId) => ({
                                                          id: roleId.trim(),
                                                          label:
                                                            employeeRoles.find(
                                                              (empRole) =>
                                                                empRole.id ===
                                                                roleId.trim(),
                                                            )?.label ?? '',
                                                        })),
                                                  )
                                                : [],
                                            );
                                        return filteredContactsRoles;
                                      });
                                      setOtherContactDiscipline(() => {
                                        if (
                                          !employeeList ||
                                          !lookups?.employeeDiscipline
                                        )
                                          return [];

                                        const filteredContactsDisciplines =
                                          employeeList
                                            .filter(
                                              (contact) => contact.id === e.id,
                                            )
                                            .flatMap((contact) =>
                                              (
                                                contact.disciplineHistoryList ||
                                                []
                                              ).map((history) => ({
                                                id:
                                                  lookups.employeeDiscipline.find(
                                                    (dis) =>
                                                      dis.code ===
                                                      history.disciplineType,
                                                  )?.code || '',
                                                label:
                                                  lookups.employeeDiscipline.find(
                                                    (dis) =>
                                                      dis.code ===
                                                      history.disciplineType,
                                                  )?.description || '',
                                              })),
                                            );

                                        // REMOVE DUPLICATES (same disciplineType)
                                        return Array.from(
                                          new Map(
                                            filteredContactsDisciplines.map(
                                              (d) => [d.id, d],
                                            ),
                                          ).values(),
                                        );
                                      });

                                      setFieldValue(
                                        'yetToAddOtherContactId',
                                        e.id,
                                      );
                                      setYetToAddContactId(e.id);
                                    } else {
                                      setYetToAddContactId('');
                                      setSelectedEmployee(null);
                                      setOthersContactsRole([]);
                                      setOtherContactDiscipline([]);
                                      formikRef.current?.setValues({
                                        ...formikRef.current?.values,
                                        yetToAddOtherContactId: '',
                                        yetToAdddisciplineId: '',
                                        yetToAddRoleId: '',
                                      });
                                    }
                                  }}
                                  fetchOptions={fetchEmployees}
                                  required
                                  disabled={
                                    isOtherLanguage() ||
                                    editRecordIndex !== null ||
                                    empEditDisable
                                  }
                                />
                              </Grid>
                              <Grid item xs={3} className="mb-md">
                                <DropdownComponent
                                  names={otherContactDiscipline}
                                  labelid="Ifsp.discipline"
                                  defaultlabelid="Select Discipline"
                                  value={values.yetToAdddisciplineId}
                                  handleChange={(e) => {
                                    setFieldValue('yetToAdddisciplineId', e);
                                  }}
                                  Required
                                  disabled={
                                    otherContactDiscipline.length === 0 ||
                                    !hasEditPermission
                                  }
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                                {errors.yetToAdddisciplineId &&
                                  touched.yetToAdddisciplineId && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.yetToAdddisciplineId}
                                      defaultlabel="Discipline is required"
                                    />
                                  )}
                              </Grid>
                              <Grid item xs={3} className="mb-md">
                                <DropdownComponent
                                  names={othersContactsRole}
                                  labelid="Ifsp.selectRole"
                                  defaultlabelid="Select Role"
                                  value={values.yetToAddRoleId}
                                  handleChange={(e) => {
                                    setFieldValue('yetToAddRoleId', e);
                                  }}
                                  Required
                                  disabled={
                                    othersContactsRole.length === 0 ||
                                    !hasEditPermission
                                  }
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                                {errors.yetToAddRoleId &&
                                  touched.yetToAddRoleId && (
                                    <MediumTypography
                                      className="errorText-md"
                                      labelid={errors.yetToAddRoleId}
                                      defaultlabel="Role is required"
                                    />
                                  )}
                              </Grid>
                              <Grid
                                container
                                xs={1}
                                className="cursorPointer "
                                onClick={() => {
                                  handleSubmit();
                                }}
                              >
                                <Grid item>
                                  <Box
                                    component="div"
                                    className="flex__ pt-xs "
                                  >
                                    <AddNew className="ml-sm mr-sm" />
                                    <MediumTypography
                                      labelid="IFSP.Add"
                                      defaultlabel="Add"
                                    />
                                  </Box>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Box>
                        )}
                        <Box component="section">
                          <TableContainer
                            component={Paper}
                            className="mt-md tableStyles"
                          >
                            <Table stickyHeader aria-label="sticky table">
                              <TableHeader
                                className="listDataTableHead"
                                headerNames={teamHeadCells}
                                checkBoxRequired={false}
                              />
                              <TableBody className="tableRowcss">
                                {intakeTeamTable.map((listData, index) => (
                                  <IfspTeamMembersTableRow
                                    key={`intake-team-${index + 1}`}
                                    data={listData}
                                    dateRequired={true}
                                    isIntakeLocked={!hasEditPermission}
                                    isIfspScreenLocked={false}
                                    onDelete={() =>
                                      handleDeleteOtherContact(index)
                                    }
                                    onEdit={async () => {
                                      formikRef.current?.setValues({
                                        ...formikRef.current?.values,
                                        PresentForIntakeVisitType: 'teamMember',
                                      });
                                      setPresentForIntakeType('teamMember');
                                      handleEditOtherContact(index);
                                    }}
                                  />
                                ))}
                              </TableBody>
                            </Table>
                            {intakeTeamTable.length === 0 && (
                              <Box
                                component="div"
                                className="width__100 flex__align__center"
                              >
                                <MediumTypography
                                  sxProps={{ backgroundColor: '#ECF9F8' }}
                                  textstyle={'center'}
                                  labelid="Intake.teamMembersemptyMessage"
                                  defaultlabel="No Team members added yet"
                                  className="p-sm"
                                />
                              </Box>
                            )}
                          </TableContainer>
                        </Box>
                      </Box>

                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        <Grid item xs={9} lg={9} className="mt-md">
                          <MediumTypography
                            labelid="IntakeCurrentHealth.childCameIntoFamily"
                            defaultlabel="How did this child come into your family? (ex. adopted, surrogacy)"
                            className="mr-md"
                          />

                          <CommentTextbox
                            Value={values.descriptions.childComeToFamilyDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={5}
                            handlechange={(e) => {
                              setFieldValue(
                                'descriptions.childComeToFamilyDesc',
                                e,
                              );
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>

                        <Grid item xs={3} lg={3} className="mt-md" />

                        <Grid item xs={3} lg={3} className="mt-md">
                          <Box className="flex__">
                            <MediumTypography
                              labelid="IntakeClientInfo.ChildAdopted"
                              defaultlabel="Is child adopted?"
                            />
                            <MediumTypography
                              labelid="Intake.Eics"
                              defaultlabel="(EICS)"
                              sxProps={{ fontStyle: 'italic' }}
                              className="ml-xs"
                            />
                          </Box>
                          <CustomRadioButton
                            data={EICSRadioData}
                            value={values.eics.childAdopted}
                            onSelectItem={(value) => {
                              if (value) {
                                setFieldValue('eics.childAdopted', value);
                              }
                            }}
                            disable
                          />
                        </Grid>

                        <Grid item xs={4} lg={4} className="mt-md">
                          <Box>
                            <MediumTypography
                              labelid="motherResidenceAtTimeOfChildBirthInMAQuestionText"
                              defaultlabel="Was mother’s residence at time of child’s birth in MA?"
                              sxProps={{ display: 'inline' }}
                            />
                            <MediumTypography
                              labelid="Intake.Eics"
                              defaultlabel="(EICS)"
                              sxProps={{
                                display: 'inline',
                                fontStyle: 'italic',
                                ml: '4px',
                              }}
                            />
                          </Box>

                          <CustomRadioButton
                            data={DPHValues}
                            value={values.eics.mothersResidenceInMACode}
                            onSelectItem={() => {}}
                            disable
                          />
                        </Grid>

                        {values.eics.mothersResidenceInMACode === 'YES' && (
                          <Grid item xs={4} lg={4} className="mt-md">
                            <Box>
                              <MediumTypography
                                labelid="motherResidenceAtTimeOfChildBirthInMAText"
                                defaultlabel="Mother’s residence at time of child’s birth?"
                                sxProps={{ display: 'inline' }}
                              />
                              <MediumTypography
                                labelid="Intake.Eics"
                                defaultlabel="(EICS)"
                                sxProps={{
                                  display: 'inline',
                                  fontStyle: 'italic',
                                  ml: '4px',
                                }}
                              />
                            </Box>
                            <Textinput
                              name="mothersCommunityCode"
                              Value={values.eics.mothersCommunityCode}
                              inputProps={{ readOnly: true }}
                              sxProps={{
                                backgroundColor: 'white',
                              }}
                            />
                          </Grid>
                        )}
                      </Grid>

                      <Box display="flex" flexDirection="row" className="mt-md">
                        <MediumTypography
                          labelid="IntakeClientInfo.anyConcernsOrQuestionsAboutThisChild"
                          defaultlabel="Please describe any concerns or questions you have about this child."
                        />
                      </Box>
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.descriptions.childConcernDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={5}
                            handlechange={(e) => {
                              setFieldValue('descriptions.childConcernDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                      <Box display="flex" flexDirection="row" className="mt-md">
                        <MediumTypography
                          labelid="IntakeClientInfo.anyConcernsOrQuestionsAboutYourFamily"
                          defaultlabel="Please describe any concerns or questions you have about your family."
                        />
                      </Box>
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.descriptions.familyConcernDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={5}
                            handlechange={(e) => {
                              setFieldValue(
                                'descriptions.familyConcernDesc',
                                e,
                              );
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                      <Box display="flex" flexDirection="row" className="mt-md">
                        <MediumTypography
                          labelid="IntakeClientInfo.prioritiesForThisChild"
                          defaultlabel="Please describe your priorities for this child."
                        />
                      </Box>
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.descriptions.childPriorityDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={5}
                            handlechange={(e) => {
                              setFieldValue(
                                'descriptions.childPriorityDesc',
                                e,
                              );
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                      <Box display="flex" flexDirection="row" className="mt-md">
                        <MediumTypography
                          labelid="IntakeClientInfo.prioritiesForYourFamily"
                          defaultlabel="Please describe your priorities for your family."
                        />
                      </Box>
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.descriptions.familyPriorityDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={5}
                            handlechange={(e) => {
                              setFieldValue(
                                'descriptions.familyPriorityDesc',
                                e,
                              );
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                      <Box display="flex" flexDirection="row" className="mt-md">
                        <MediumTypography
                          labelid="IntakeClientInfo.whenThinkingAboutYourConcernsAndPrioritiesForThisChild"
                          defaultlabel="When thinking about your concerns and priorities for this child and your family, how could working with Early Intervention support you and your family?"
                        />
                      </Box>
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={
                              values.descriptions.earlyInterventionSupportDesc
                            }
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={5}
                            handlechange={(e) => {
                              setFieldValue(
                                'descriptions.earlyInterventionSupportDesc',
                                e,
                              );
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>

                      <Box className="mt-md">
                        <Box className="flex__">
                          <MediumTypography
                            labelid="IntakeClientInfo.ChildBornMA"
                            defaultlabel="Was this child born in MA ?"
                          />
                          <MediumTypography
                            labelid="Intake.Eics"
                            defaultlabel="(EICS)"
                            sxProps={{ fontStyle: 'italic' }}
                            className="ml-xs"
                          />
                        </Box>
                        <CustomRadioButton
                          data={EICSRadioData}
                          value={values.eics.childBorn}
                          onSelectItem={(value) => {
                            if (value) {
                              setFieldValue('eics.childBorn', value);
                            }
                          }}
                          disable
                        />
                      </Box>

                      <Box className="mt-md">
                        <MediumTypography
                          labelid="Intake.additionalCommentsTitle"
                          defaultlabel="Additional Comments"
                          fontSize="16px"
                          fontweight={600}
                          textColor="#2A4241"
                        />
                      </Box>
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.comment}
                            placeholder="Comments"
                            name="comment"
                            rows={5}
                            maxLength={3000}
                            handlechange={(e) => {
                              setFieldValue('comment', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                );
              }}
            </Formik>
            <ModalPopup
              description="formUnsavedChangesMessage"
              open={openModal}
              onCancel={() => {
                setOpenModal(false);
              }}
              onOk={() => {
                setEmpEditDisable(false);
                setEditRecordIndex(null);
                setOthersContactsRole([]);
                setOtherContactDiscipline([]);
                formikRef.current?.resetForm();

                setIntakeTeamTable(initialIntakeTeamTable);

                setIntakeClientInfo({
                  ...IntakeFormInitialValues,
                  demographics: intakeClientInfo.demographics,
                  insurance: intakeClientInfo.insurance,
                  eics: intakeClientInfo.eics,
                  descriptions: intakeClientInfo.descriptions,
                  dateOfIntakeVisit: intakeClientInfo.dateOfIntakeVisit,
                  presentForIntakeVisits: {
                    teamMembers: initialTeamMembers,
                    guardians: initiaGurdians,
                  },
                });
                setOpenModal(false);
              }}
              labelId1="Clientpage.Nobtn"
              negativeActionLabel="No"
              labelId2="Clientpage.Yesbtn"
              positiveActionLabel="Yes"
            />
          </Box>
        </Card>
        <Box
          className="mt-md mb-xlg"
          display={'flex'}
          justifyContent={'flex-end'}
        >
          <ButtonComponent
            className="btn-primary btn-cancel alrt_Width_btn mr-md"
            variantType="contained"
            labelId={'cancelText'}
            defaultLabelId={'Cancel'}
            sxProps={{
              display: hasEditPermission ? 'auto' : 'none',
            }}
            onClick={() => {
              if (
                !_.isEqual(intakeClientInfo, formikRef.current?.values) ||
                !_.isEqual(initialIntakeTeamTable, intakeTeamTable)
              ) {
                setOpenModal(true);
              }
            }}
          />

          <ButtonComponent
            variantType="contained"
            type="submit"
            className="btn-primary btn-submit alrt_Width_btn"
            labelId={'Intake.submit'}
            defaultLabelId={'Save'}
            sxProps={{
              display: hasEditPermission ? 'auto' : 'none',
            }}
            onClick={async () => {
              formikRef.current?.setTouched({}, false);
              handleSubmitForm();
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default IntakeClientsInfo;
